export default __webpack_public_path__ + "e9bc9933bcdc2ca7d5f9bdd807f3b993.svg";